import React from "react";
import ConfirmationModal from "../ConfirmationModal";
import ErrorBanner from "../ErrorBanner";
import SectionTabsPageHeader from "../SectionTabsPageHeader";

/**
 * Page shell: title, error banner, confirmation modal (supports Project-style `confirmDialog.mode`),
 * then custom top content and list region.
 */
export default function EntityPageScaffold({
  title,
  /** When set, replaces the default `<h1>` with tab navigation (e.g. Volunteer section tabs). */
  titleTabs = null,
  subtitle,
  bannerError,
  onDismissBanner,
  confirmDialog,
  onConfirmModal,
  onCancelModal,
  pageTopAfterModal,
  list,
  /** Extra class on `.page-container` (e.g. `page-container--stock-mgmt`). */
  containerClassName = "",
}) {
  const effectiveMode =
    confirmDialog.mode === "alert" ? "alert" : confirmDialog.onConfirm ? "confirm" : "alert";
  const confirmLabel = effectiveMode === "alert" ? "OK" : undefined;
  const sectionTabsLayout = Boolean(titleTabs);
  const containerClasses = [
    "page-container",
    sectionTabsLayout ? "page-container--section-tabs" : "",
    containerClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      {sectionTabsLayout ? (
        <SectionTabsPageHeader subtitle={subtitle}>{titleTabs}</SectionTabsPageHeader>
      ) : null}
      <div className="page-content">
        <div className="page-top">
          {!sectionTabsLayout ? (
            <div className="page-header">
              <h1 className="page-title">{title}</h1>
              {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
            </div>
          ) : null}
          <ErrorBanner message={bannerError} onDismiss={onDismissBanner} />
          <ConfirmationModal
            open={confirmDialog.open}
            title={confirmDialog.title || "Confirm"}
            message={confirmDialog.message}
            mode={effectiveMode}
            confirmLabel={confirmDialog.confirmLabel ?? confirmLabel}
            contentMaxWidth={confirmDialog.contentMaxWidth}
            onConfirm={onConfirmModal}
            onCancel={onCancelModal}
          />
          {pageTopAfterModal}
        </div>
        {list}
      </div>
    </div>
  );
}
